module.exports = __webpack_public_path__ + "static/media/readiness-radio-inactive.8d0d3dfc.svg";